/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { View } from 'backbone.marionette';

import lazyLoadView from '@/util/lazyLoadView';
import SearchCommandsInt from '@/services/SearchCommandsInt';

import IntDashboardSidebarNavView from '../../../internal-dashboard/views/IntDashboardSidebarNavView';
import GetAllRegions from '../../../common/services/GetAllRegions';
import GetAllServiceBranches from '../../../common/services/GetAllServiceBranches';
import loadSearchFields from '../../../login/loaders/SearchFieldsViewLoader';
import CommandDashboardGridView from '../../views/CommandDashboardGridView';

import tmplCommandDashboardPage from './CommandDashboardPage.hbs';

const CommandDashboardPage = View.extend({
  template: tmplCommandDashboardPage,

  ui: {
    sideBar: '.sidebar-nav-container',
    searchFieldsView: '.search-fields-view',
    commandsGrid: '#commandsGrid'
  },

  regions: {
    sideBar: '@ui.sideBar',
    searchFieldsView: '@ui.searchFieldsView',
    commandsGrid: '@ui.commandsGrid'
  },

  childViewEvents: {
    'search:response': 'onSearchResponse'
  },

  onSearchResponse(response) {
    this.$('.result-count').empty().append(`<span><b>Total Result Count: ${response.totalCount}</b></span>`);
    this.commandsGrid.collection.fullCollection.reset(response.commands);
  },

  onRender() {
    this.showChildView('sideBar', new IntDashboardSidebarNavView({ mode: 'commands' }));

    const searchFields = [
      {
        id: 'dodac-search-field',
        name: 'dodac',
        class: 'InputSearchField',
        placeholder: 'DODAAC'
      },
      {
        id: 'command-id-search-field',
        name: 'commandID',
        class: 'InputSearchField',
        placeholder: 'Command ID',
        dataParsleyType: 'integer'
      },
      {
        id: 'command-name-search-field',
        name: 'commandName',
        class: 'InputSearchField',
        placeholder: 'Command Name'
      },
      {
        id: 'service-branch-id-search-field',
        name: 'serviceBranchID',
        class: 'SelectSearchField',
        placeholder: 'Branch',
        lookupService: GetAllServiceBranches
      },
      {
        id: 'region-id-search-field',
        name: 'regionID',
        class: 'SelectSearchField',
        placeholder: 'Location',
        lookupService: GetAllRegions
      }
    ];

    this.showChildView(
      'searchFieldsView',
      lazyLoadView(() => loadSearchFields(searchFields, SearchCommandsInt))
    );

    this.commandsGrid = new CommandDashboardGridView({});

    this.showChildView('commandsGrid', this.commandsGrid);
  }
});

export default CommandDashboardPage;
